import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Xehopdongtonghop from "components/Xehopdong/Xehopdongtonghop.js";
export default function BCXehopdong() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo tháng xe hợp đồng",
            tabContent: <Xehopdongtonghop />,
          },
        ]}
      />
    </div>
  );
}
